module.exports = __webpack_public_path__ + "assets/typescript.3de182d2.svg";